import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

/**
 * Mobile-friendly close button for drawers
 * 
 * Displays a floating button at the bottom of drawers on mobile devices (<768px)
 * to provide thumb-friendly close functionality. Hidden on tablet/desktop.
 * 
 * @example
 * ```html
 * <app-drawer-mobile-close
 *   [closeLabel]="'activity.inbox.close'"
 *   [iconType]="'down'"
 *   (closeClick)="handleClose()"
 * />
 * ```
 */
@Component({
  selector: 'app-drawer-mobile-close',
  standalone: true,
  imports: [CommonModule, NzButtonModule, NzIconModule, TranslatePipe],
  templateUrl: './drawer-mobile-close.component.html',
  styleUrls: ['./drawer-mobile-close.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerMobileCloseComponent {
  /**
   * Icon type for close button ('close', 'down', 'arrow-down')
   * @default 'down'
   */
  iconType = input<string>('down');

  /**
   * Translation key for close label
   * @default 'common.close'
   */
  closeLabel = input<string>('common.close');

  /**
   * Control button visibility (for animations, scroll states)
   * @default true
   */
  visible = input<boolean>(true);

  /**
   * Emit close event when button is clicked
   */
  closeClick = output<void>();

  close(): void {
    this.closeClick.emit();
  }
}
